// extracted by mini-css-extract-plugin
export default {"empty-question":"EmptyQuestions_empty-question__gXXj7"};